// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"db1aa2b5","677":"aafcff3d"}[chunkId] + ".chunk.js";
};